(function () {
	'use strict';

	var module = angular.module('uwAgenda.agenda');

	// directive for agenda-day
	module.directive('agendaDayTime', [
		'$rootScope',
		'AgendaOverviewService',
		'$sce',
		'$translate',
		'IntegratorTypeEnum',
		function ($rootScope, AgendaOverviewService, $sce, $translate, IntegratorTypeEnum) {
			var directive = {
				restrict: 'A',
				templateUrl: '/app/agenda/templates/agenda-day-time.template.html',
				controller: 'AgendaDayTimeController',
				controllerAs: 'vm',
				scope: {
					time: '=',
					date: '=?', // only set if we come from WEEK-View
					showDate: '@?', // show/hide the appointmentdate
					daysInWeek: '@?', // days in week to show
					actionsDisabled: '@?',
				},
				bindToController: true,
				link: link,
			};
			return directive;

			function link(scope, element) {
				scope.IntegratorTypeEnum = IntegratorTypeEnum;
				scope.isWeekView = false;

				scope.tooltip = '';
				if (scope.vm.time.showDayItSelfTimeLimitWarning) {
					scope.tooltip = $translate.instant('agenda_label_time_limit', {
						uur: scope.vm.time.dayItselfTimeLimitHour,
					});
				} else if (scope.vm.time.autoHour) {
					scope.tooltip = $translate.instant('auto_hour_tooltip', {
						label: scope.vm.time.applicableToLabelCaption,
					});
				} else if (scope.vm.time.reverseAutoHour) {
					scope.tooltip = $translate.instant('reverse_auto_hour_tooltip', {
						label: scope.vm.time.applicableToLabelCaption,
					});
				}
				if ($rootScope.isRingfoon) {
					// Ringfoon Operators see INTERN-Caption
					scope.vm.time.agendaLabelCaption =
						scope.vm.time.agendaLabelCaptionIntern ||
						scope.vm.time.agendaLabelCaption;

					if (AgendaOverviewService.data.weekView === true) {
						scope.isWeekView = true;
					}
				} else {
					if (AgendaOverviewService.data.weekView === true) {
						// week-view
						scope.isWeekView = true;
					}
				}

				// convert to boolean and set default-value if null
				scope.showDate =
					scope.vm.showDate && scope.vm.showDate === 'true' ? true : false;
				scope.actionsDisabled =
					scope.vm.actionsDisabled && scope.vm.actionsDisabled === 'true'
						? true
						: false;

				if (
					scope.vm.time.content !== null &&
					scope.vm.time.content !== undefined
				) {
					// trust as html for popover
					scope.vm.time.trustedContent = $sce.trustAsHtml(
						scope.vm.time.content
					);
					// short content
					scope.vm.time.shortContent = scope.vm.time.content.replace(
						/<(?:.|\n)*?>/gm,
						''
					);
				} // if

				scope.showAppointment = function () {
					scope.vm.showAppointmentDetailModal();
				};
			}
		},
	]);
})();
